export const hospitalOrganizationColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'revint_id',
  'facility_mnemonic',
  'facility_offset',
  'federal_tax_id',
  'health_system_id',
  'health_system_name',
  'npi',
  'provider_name',
  'ptan',
  'snapshot_id',
];
